const postedAtMs = (postedAt: string | null | undefined): number => {
  if (!postedAt) return Number.NEGATIVE_INFINITY;
  const time = new Date(postedAt).getTime();
  return Number.isNaN(time) ? Number.NEGATIVE_INFINITY : time;
};

export const byPostRecencyDesc = (
  a: { postedAt?: string | null },
  b: { postedAt?: string | null },
): number => {
  const recencyA = postedAtMs(a.postedAt);
  const recencyB = postedAtMs(b.postedAt);
  if (recencyA === recencyB) return 0;
  return recencyB > recencyA ? 1 : -1;
};
